import * as React from "react";
const SvgFiRrEmployeeAlt = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-employee-alt_svg__a)">
      <path
        fill="#062147"
        d="M10 15a1 1 0 0 1-1 1c-3.86 0-7 3.14-7 7a1 1 0 0 1-2 0c0-4.962 4.038-9 9-9a1 1 0 0 1 1 1m14 2.5v3c0 1.93-1.57 3.5-3.5 3.5h-5c-1.93 0-3.5-1.57-3.5-3.5v-3c0-1.758 1.308-3.204 3-3.449V14c0-1.103.897-2 2-2h2c1.103 0 2 .897 2 2v.051c1.692.245 3 1.691 3 3.449m-10 0v.5h8v-.5c0-.827-.673-1.5-1.5-1.5h-5c-.827 0-1.5.673-1.5 1.5m8 3V20h-3a1 1 0 0 1-2 0h-3v.5c0 .827.673 1.5 1.5 1.5h5c.827 0 1.5-.673 1.5-1.5M.873 12.822c.308-1.306 1.854-7.849 2.026-8.385A6.39 6.39 0 0 1 9 0a6.39 6.39 0 0 1 6.101 4.437c.033.101.132.408 1.303 5.332.128.537-.201 1.231-.974 1.231a1 1 0 0 1-.972-.769c-1.06-4.456-1.233-5.092-1.261-5.181a4.4 4.4 0 0 0-1.675-2.256 6.67 6.67 0 0 1-2.669 3.185A6.7 6.7 0 0 1 5.307 7c-.055 0-.111-.008-.167-.01.444 1.725 1.999 3.009 3.861 3.009a4 4 0 0 0 2-.535.999.999 0 1 1 1.001 1.731 5.997 5.997 0 0 1-8.171-2.169c-.344 1.439-.717 3.01-1.01 4.253a1 1 0 0 1-.972.771c-.741 0-1.101-.692-.974-1.229zm3.969-7.864a4.67 4.67 0 0 0 2.952-.675 4.7 4.7 0 0 0 1.863-2.23 4.392 4.392 0 0 0-4.815 2.905"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-employee-alt_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrEmployeeAlt;
